// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import axios from 'axios'
import http from './utils/http'
import Vuex from 'vuex'
import store from './store/store'

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);

Vue.config.productionTip = false
Vue.prototype.$axios = http

/** GLOBAL URL **/
// global.GLOBAL_URL = "http://www.emall.com/"; //线下
global.GLOBAL_URL = "https://api.zyzl.affbc.cn/"; //线上
global.GLOBAL_UPLOAD_URL = global.GLOBAL_URL+"admin/upload/";

import VueUeditorWrap from 'vue-ueditor-wrap';
Vue.component('vue-ueditor-wrap', VueUeditorWrap);

router.beforeEach((to, from, next) => {
	ViewUI.LoadingBar.start();
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		document.title = to.meta.title
	}
	next();
});

router.afterEach(route => {
	ViewUI.LoadingBar.finish();
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
	store,
	Vuex,
	axios,
	components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js